var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('apexchart',{attrs:{"width":"100%","type":"radialBar","options":_vm.chartoptions,"series":[_vm.deletingProportion]}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }